import { render, staticRenderFns } from "./2-select-options.vue?vue&type=template&id=87f1c52c&scoped=true"
import script from "./2-select-options.vue?vue&type=script&lang=js"
export * from "./2-select-options.vue?vue&type=script&lang=js"
import style0 from "./2-select-options.vue?vue&type=style&index=0&id=87f1c52c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f1c52c",
  null
  
)

export default component.exports